export function compareCollectionText(
  left: string | null,
  right: string | null,
  collator: Intl.Collator,
  direction: 1 | -1,
): number {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  return collator.compare(left, right) * direction;
}
